import { Directive, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';

import { fromEvent, Observable, Subject } from 'rxjs';
import { filter, switchMap, take, takeUntil } from 'rxjs/operators';

@Directive({
    selector: '[shClickOutside]',
    standalone: true
})
export class ShClickOutsideDirective implements OnInit, OnDestroy {
    private readonly destroy$: Subject<void> = new Subject<void>();

    private clickedInsideEvent$!: Observable<MouseEvent>;
    private clickedOutsideEvent$!: Observable<MouseEvent>;

    @Input('shClickOutsideFocusEvent') focusEvent = 'click';

    @Output()
    public shClickOutside: EventEmitter<boolean> = new EventEmitter<boolean>();

    constructor(private readonly elementRef: ElementRef) {}

    ngOnInit(): void {
        this.setupClickStreams();
        this.unfocusWhenOutside();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    private setupClickStreams(): void {
        this.clickedInsideEvent$ = fromEvent<MouseEvent>(this.elementRef.nativeElement, this.focusEvent);
        this.clickedOutsideEvent$ = fromEvent<MouseEvent>(document, 'click').pipe(
            filter((ev: MouseEvent) => this.didClickOutside(ev.target as HTMLElement))
        );
    }

    private unfocusWhenOutside(): void {
        this.clickedInsideEvent$
            .pipe(
                switchMap(() => this.clickedOutsideEvent$.pipe(take(1))),
                takeUntil(this.destroy$)
            )
            .subscribe(() => this.shClickOutside.emit(true));
    }

    private didClickOutside(element: HTMLElement): boolean {
        return !this.elementRef.nativeElement.contains(element);
    }
}
